import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetLevelOneApi } from "../LevelOne/LevelOneAction";
import { GetLevelTwoWithLevelOneIDApi } from "../LevelTwo/LevelTwoAction";
import { UploadLevelFourFileApi } from "./LevelFourAction";
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelThreeWithLevelTwoIDApi } from "../LevelThree/LevelThreeAction";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import Swal from 'sweetalert';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const UploadLevelFour = (props) => {
    const [levelOneId, setLevelOneId] = useState();
    const [levelOneName, setLevelOneName] = useState();
    const [levelTwoId, setLevelTwoId] = useState();
    const [levelTwoName, setLevelTwoName] = useState();
    const [levelThreeId, setLevelThreeId] = useState();
    const [levelThreeName, setLevelThreeName] = useState();
    const [uploadLevelFourFile, setUploadLevelFourFile] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    function SaveLevelFour() {
        props.UploadLevelFourFileApi({
            levelOneId: levelOneId,
            levelOneName: levelOneName,
            levelTwoId: levelTwoId,
            levelTwoName: levelTwoName,
            levelThreeId: levelThreeId,
            levelThreeName: levelThreeName,
            file: uploadLevelFourFile,
        },
            handleVisible,
            handleDangerVisible
        );
        setLevelOneId("")
        setLevelTwoId("")
        setLevelThreeId("")
    }
    const handleVisible = (msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    }
    const handleDangerVisible = (error) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Ok",
        });
    }


    const handleChangeLevelOne = (selectedOption) => {
        setLevelOneId(selectedOption.value);
        setLevelOneName(selectedOption.label);
        props.GetLevelTwoWithLevelOneIDApi(selectedOption.value)
    };
    const getLevelOneList = !_.isEmpty(props.levelOneList) && props.levelOneList.data.map((x) => {
        let data = { value: x._id, label: `${x.key} - ${x.name}` };
        return data;
    });

    const handleChangeLevelTwo = (selectedOption) => {
        setLevelTwoId(selectedOption.value);
        setLevelTwoName(selectedOption.label);
        props.GetLevelThreeWithLevelTwoIDApi(selectedOption.value)
    };
    const getLevelTwoList = !_.isEmpty(props.levelTwoWithLevelOneIdList) && props.levelTwoWithLevelOneIdList.map((x) => {
        let data = { value: x._id, label: `${x.allKey} - ${x.levelTwoName}` };
        return data;
    });

    const handleChangeLevelThree = (selectedOption) => {
        setLevelThreeId(selectedOption.value);
        setLevelThreeName(selectedOption.label);
        props.GetLevelThreeWithLevelTwoIDApi(selectedOption.value)
    };
    const getLevelThreeList = !_.isEmpty(props.levelThreeWithLevelTwoIdList) && props.levelThreeWithLevelTwoIdList.map((x) => {
        let data = { value: x._id, label: `${x.allLevlKey} - ${x.levelThreeName}` };
        return data;
    });

    useEffect(() => {
        props.GetLevelOneApi();
        props.setHeading("Upload Level Four");
    }, []);

    return (
        <>
            {props.isFetchingLevelOne || props.isUploadingLevelFour || props.isFetchingAccountType ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 1 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 1"
                                    onChange={handleChangeLevelOne}
                                    options={getLevelOneList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 2 *</b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(levelOneId)}
                                    placeholder="Select Level 2"
                                    onChange={handleChangeLevelTwo}
                                    options={getLevelTwoList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 3 *</b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(levelTwoId)}
                                    placeholder="Select Level 3"
                                    onChange={handleChangeLevelThree}
                                    options={getLevelThreeList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label><b>Upload Level 4 File *</b></Form.Label>
                                <Form.Control
                                    placeholder="Upload Level Four File"
                                    type="file"
                                    accept=".xls, .xlsx"
                                    onChange={(e) => setUploadLevelFourFile(e.target.files[0])}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(levelOneId) || _.isEmpty(levelTwoId) || _.isEmpty(levelThreeId) || !uploadLevelFourFile ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> UPLOAD FILE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveLevelFour}> UPLOAD FILE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetLevelThreeWithLevelTwoIDApi: (levelTwoId) => dispatch(GetLevelThreeWithLevelTwoIDApi(levelTwoId)),
        setHeading: (data) => dispatch(setHeading(data)),
        GetLevelOneApi: () => dispatch(GetLevelOneApi()),
        GetLevelTwoWithLevelOneIDApi: (levelOneId) => dispatch(GetLevelTwoWithLevelOneIDApi(levelOneId)),
        UploadLevelFourFileApi: (data, handleVisible, handleDangerVisible) => dispatch(UploadLevelFourFileApi(data, handleVisible, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isUploadingLevelFour: state.LevelFourReducer.isUploadingLevelFour,
    isFetchingLevelOne: state.LevelOneReducer.isFetchingLevelOne,
    levelOneList: state.LevelOneReducer.levelOneList,
    levelTwoWithLevelOneIdList: state.LevelTwoReducer.levelTwoWithLevelOneIdList,
    levelThreeWithLevelTwoIdList: state.LevelThreeReducer.levelThreeWithLevelTwoIdList,
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadLevelFour);